module.exports = __webpack_public_path__ + "static/media/winner.895562ac.png";